<template>
  <v-app>
    <v-container fluid class="px-0 py-0">
      <v-main>
        <router-view/>
      </v-main>
    </v-container>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    scrollDirection: null
  }),

  methods: {
    setScrollDirection (direction) {
      const ROOT = this
      this.scrollDirection = direction
      this.$store.dispatch('setValue', { name: 'scrollDirection', newValue: ROOT.scrollDirection })
    }
  },

  mounted () {
    // from stackoverflow
    let lastScrollTop = window.pageYOffset || window.scrollTop

    window.addEventListener(
      'scroll',
      () => {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop

        if (scrollPosition > lastScrollTop) {
          // downscroll code
          this.setScrollDirection('down')
        } else {
          // upscroll code
          this.setScrollDirection('up')
        }

        lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition // For Mobile or negative scrolling
      },
      false
    )
  }
}
</script>
